// Enums
export enum AgeCategory {
  Adult = 'Adult',
  AdultStudent = 'AdultStudent',
  YouthChildren = 'YouthChildren',
  NeedsSelection = 'NeedsSelection',
  MustChange = 'MustChange'
}

export enum YouthChildrenSubCategory {
  Nursery = 'Nursery',
  PreSchool = 'PreSchool',
  GradeP5 = 'Grade P-5',
  Grade68 = 'Grade 6-8',
  Grade912 = 'Grade 9-12'
}

// System fields interface
export interface SystemFields {
  recordId: string;
  createdDate: Date;
  lastModifiedDate: Date;
  deleted?: boolean;  // Flag to indicate if the record is deleted
  deletedDate?: Date; // Date when the record was deleted
}

// Note interface
export interface Note {
  id: string;
  content: string;
  createdDate: Date;
  createdBy: string;
  lastModifiedDate: Date;
  isPersistent: boolean;  // Flag to indicate if note should persist across years
}

// Dependant interface
export interface Dependant {
  FirstName: string;
  LastName: string;
  Age: AgeCategory;
  YouthChildrenCategory?: YouthChildrenSubCategory;
}

// Primary Camper interface
export interface PrimaryCamper extends SystemFields {
  // Personal Information
  FirstName: string;
  LastName: string;
  Age: AgeCategory;

  // Contact Information
  email: string;
  HomePhone: string;
  MobilePhone: string;

  // Address
  Street: string;
  Town: string;
  Province: string;
  PostalCode: string;

  // Vehicle
  LicensePlate: string;

  // Login Status
  loginExists?: boolean;
  authUid?: string | null;  // Firebase Auth UID

  // Dependants
  dependants: Dependant[];

  // Notes
  notes: Note[];

  // PAR dollar amount
  par?: number;
}

// Selected Camper type for registration
export type SelectedCamper = {
  firstName: string;
  lastName: string;
  age: AgeCategory;
  youthChildrenCategory?: YouthChildrenSubCategory;
};

// Firestore collection name constant
export const CAMPERS_COLLECTION = 'primaryCampers'; 